import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { selectCurrentCustomer } from "@/redux/slices/customerAuthSlice";

// Blocks access to any customer app route until an admin-created,
// first-time-login customer has changed their temporary password.
const RequireCustomerPasswordChange = () => {
  const user = useSelector(selectCurrentCustomer);

  if (user?.is_created_by_admin === 1 && user?.is_first_login === 1) {
    return <Navigate to="/sfs-change-password-first-login" replace />;
  }

  return <Outlet />;
};

export { RequireCustomerPasswordChange };
